@if (type === 'text') {
  <p-columnFilter
    type="text"
    [field]="field"
    matchMode="contains"
    [matchModeOptions]="textMatchModeOptions"
    [showMenu]="true"
    [showOperator]="false"
    [showAddButton]="false"
    display="menu"
  ></p-columnFilter>
} @else {
  <p-columnFilter [field]="field" [matchMode]="matchMode" [showMenu]="true" display="menu">
    <ng-template pTemplate="filter" let-filterCallback="filterCallback">
      <p-multiSelect
        [options]="checklistOptions"
        optionLabel="label"
        optionValue="value"
        [placeholder]="placeholder"
        [filter]="showSearch"
        [style]="{ minWidth: minWidth }"
        panelStyleClass="excel-filter-panel"
        (onChange)="filterCallback($event.value)"
      ></p-multiSelect>
    </ng-template>
  </p-columnFilter>
}

